import {
  IonAlert,
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonLoading,
  IonPage,
  IonTitle,
  IonToast,
  IonToolbar
} from '@ionic/react'
import { addCircle, home } from "ionicons/icons"
import React, { useState } from 'react'
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import EigenheimSteps from "../../components/eigenheim.steps"
import FormPaymentTerm from '../../components/form/payment.term'
import PersonCard, { Person } from "../../components/form/person.card"
import Note from "../../components/note"
import { State } from '../../store'
import {
  setAdditional,
  setAdditionalType,
  setPaymentTerm,
  setPaymentTermType
} from "../../store/quote"

interface StateProps {
  decoded: any;
  paymentTerm: string
  additional: any;
}

interface DispatchProps {
  setPaymentTerm: setPaymentTermType
  setAdditional: setAdditionalType;
}

type Props = StateProps & DispatchProps & RouteComponentProps<{}>

const Additional: React.FC<Props> = (props) => {
  React.useEffect(() => {
    if (!props.decoded) {
      props.history.push({ pathname: '/home' })
    }
  }, [props.decoded])

  const decoded = props.decoded || {
    address: {},
    building: {},
    additional: {},
  }

  if (!decoded.addtional) {
    decoded.addtional = {}
  }

  if (!decoded.addtional.people) {
    decoded.addtional.people = []
  }

  const [exitConfirm, setExitConfirm] = useState(false)
  const [showLoading, setShowLoading] = useState(false);
  const [toast, setToast] = useState<string>('');
  const [paymentTerm, setPaymentTerm] = useState(props.paymentTerm)


  const [animals, setAnimals] = useState(props.additional.horses > 0 || props.additional.dogs > 0 || decoded.addtional.horses > 0 || decoded.addtional.dogs > 0)
  const [hasPeople, setHasPeople] = useState((props.additional.people || []).length > 0 || decoded.addtional.people.length > 0)
  const [pool, setPool] = useState(!!props.additional.pool || !!decoded.addtional.pool)

  const [horses, setHorses] = useState(`${props.additional.horses || decoded.addtional.horses || 0}`)
  const [dogs, setDogs] = useState(`${props.additional.dogs || decoded.addtional.dogs || 0}`)
  const [people, setPeople] = useState<Person[]>(props.additional.people || decoded.addtional.people)

  React.useEffect(() => {
    if (!hasPeople || people.length > 0) {
      return
    }

    setPeople([{
      id: Date.now(),
      firstName: '',
      lastName: '',
      birthday: '',
      gender: ''
    }])
  }, [hasPeople])

  const confirm = async () => {
    if (animals && Number(horses) === 0 && Number(dogs) === 0) {
      setToast('Pferde oder Hunde fehlen!')
      return
    }

    if (!(!hasPeople || (people.length > 0 && people.reduce<boolean>((valid, person) => {
      return valid && !!person.firstName && !!person.lastName && !!person.gender && !!person.birthday
    }, true)))) {
      setToast('Personen Daten fehlen!')
      return
    }

    setShowLoading(true);

    await props.setAdditional({
      pool,
      horses: animals ? Number(horses) : '',
      dogs: animals ? Number(dogs) : '',
      people: hasPeople ? people : [],
      buildings: props.additional.buildings || [],
    })

    await props.setPaymentTerm(paymentTerm)

    setShowLoading(false)
    props.history.push({ pathname: '/summary' })
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/home' })}>
              <IonIcon slot="icon-only" icon={home} />
            </IonButton>
          </IonButtons>
          <IonTitle>Eigenheim Versicherung</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Verarbeite...'}
        />
        <IonToast
          isOpen={Boolean(toast)}
          color={'warning'}
          onDidDismiss={() => setToast('')}
          message={toast}
          duration={1500}
        />

        <EigenheimSteps current={3}/>

        <Note>
          Gibt es noch etwas das wir wissen sollten?
        </Note>

        <IonItemGroup style={{marginTop: '16px', marginLeft: -16, marginRight: -16}}>
          <IonItem>
            <IonLabel>Pool?</IonLabel>
            <IonCheckbox slot="end" checked={pool} onClick={() => setPool(!pool)} />
          </IonItem>
          <IonItem>
            <IonLabel>Pferd oder Hund?</IonLabel>
            <IonCheckbox slot="end" checked={animals} onClick={() => setAnimals(!animals)} />
          </IonItem>
          <IonItem>
            <IonLabel>Zusätzliche Personen in der Haftpflicht Versicherung?</IonLabel>
            <IonCheckbox slot="end" checked={hasPeople} onClick={() => setHasPeople(!hasPeople)} />
          </IonItem>
        </IonItemGroup>

        <IonItemGroup style={{marginTop: '32px', marginLeft: -16, marginRight: -16, display: animals ? null : 'none'}}>
          <IonItemDivider>
            <IonLabel>Haustiere</IonLabel>
          </IonItemDivider>

          <IonItem>
            <IonLabel position="floating">Pferde</IonLabel>
            {/*<IonRange pin={true} min={0} max={10} step={1} snaps={true} value={parseInt(horses)} onIonChange={e => setHorses(e.detail.value as any)} />*/}
            <IonInput value={horses} type={'number'} min={'0'} max={'10'} onIonChange={e => setHorses((e.target as HTMLInputElement).value)} />
          </IonItem>
          <IonItem>
            <IonLabel position="floating">Hunde</IonLabel>
            <IonInput value={dogs} type={'number'} min={'0'} max={'10'} onIonChange={e => setDogs((e.target as HTMLInputElement).value)} />
          </IonItem>
        </IonItemGroup>

        <IonItemGroup style={{marginTop: '32px', marginLeft: -16, marginRight: -16, display: hasPeople ? null : 'none'}}>
          <IonItemDivider>
            <IonLabel>Personen</IonLabel>
            <IonButton slot="end" onClick={() => setPeople([...people, {
              id: Date.now(),
              firstName: '',
              lastName: '',
              birthday: '',
              gender: ''
            }])}>
              <IonIcon icon={addCircle}/> &nbsp; weitere Person
            </IonButton>
          </IonItemDivider>

          {people.map((person) => (
            <PersonCard
              person={person}
              onDelete={() => setPeople(people.filter((o) => o.id !== person.id))}
              onChange={p => setPeople(people.map((o) => o.id === person.id ? p : o))}
              key={person.id}
            />
          ))}
        </IonItemGroup>

        <IonItemGroup style={{marginTop: '32px', marginLeft: -16, marginRight: -16}}>
          <FormPaymentTerm value={paymentTerm} onChange={setPaymentTerm} />
        </IonItemGroup>

        <Note>
          In der Zusammenfassung erhalten sie eine Vollständige Übersicht über die Leistungen.
        </Note>

        <IonAlert
          isOpen={exitConfirm}
          onDidDismiss={() => setExitConfirm(false)}
          header={'Neu starten?'}
          message={'Alle eingegeben Daten werden verworfen und der Prozess beginnt von vorn!'}
          /*buttons={[
            'Abbrechen',
            {
              text: 'Neu Starten!',
              handler: () => {
                props.history.push({ pathname: '/home' })
              }
            }
          ]}*/
        />
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => props.history.push({ pathname: '/building' })}>
              Zurück
            </IonButton>
          </IonButtons>
          <IonButton color="primary" expand={'block'} onClick={() => confirm()}>weiter</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default connect<StateProps, DispatchProps, unknown, State>(
  ({scan, quote}) => {
    console.log('quote', quote)
    return {
      decoded: scan.decoded,
      additional: quote.additional,
      paymentTerm: quote.paymentTerm,
    }
  },
  {
    setAdditional,
    setPaymentTerm,
  }
)(Additional);
